import { actionNameGenerator } from "./../../../utils/commonUtil";
const domainPrefix = "docCenter";
const dcActionNameGenerator = actionNameGenerator(domainPrefix);

export const checkboxSelectType = dcActionNameGenerator('checkboxSelect');
export const dropdownSelectType = dcActionNameGenerator('dropdownSelect');

export const fetchStartDateType = dcActionNameGenerator('fetchStartDate');
export const fetchEndDateType = dcActionNameGenerator('fetchEndDate');
export const viewButtonClickType = dcActionNameGenerator('viewButtonClick');
export const downloadClickType = dcActionNameGenerator('downloadClick');

export const exitClickType = dcActionNameGenerator('exitClick');
export const okClickType = dcActionNameGenerator('okClick');
export const showMoreClickType = dcActionNameGenerator('showMoreClick');
export const filterGridDataType = dcActionNameGenerator('filterGridData');
export const switchButtonType = dcActionNameGenerator('switchButton');
export const fetchDocCentreDataType = dcActionNameGenerator('fetchDocCentreData');
export const accordionCheckboxSelectType = dcActionNameGenerator('accordionCheckboxSelect');
export const multiSelectOptionType = dcActionNameGenerator('multiSelectOption');
export const timeFrameChangeType = dcActionNameGenerator('timeFrameChange');
export const docCentreDataSuccessType = dcActionNameGenerator('docCentreDataSuccess');
export const docCentreDataFailureType = dcActionNameGenerator('docCentreDataFailure');

